import { render } from "./RequestsTable.vue?vue&type=template&id=9e266dde"
import script from "./RequestsTable.vue?vue&type=script&lang=js"
export * from "./RequestsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__